export function isExpired(timestamp: number | undefined): boolean {
  return timestamp != null && timestamp < Date.now();
}
